import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");

// Clear any pre-rendered/cached content injected by deployment platform
if (rootEl.children.length > 0) {
  rootEl.replaceChildren();
}

// Also remove any sibling elements injected outside root (old cached pages)
const body = document.body;
Array.from(body.children).forEach(el => {
  if (el.id !== "root" && el.tagName !== "SCRIPT" && el.tagName !== "NOSCRIPT") {
    el.style.display = "none";
    el.remove();
  }
});

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
